import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios/axiosUmbraco";
import AboutUsSlider from "../components/AboutUsSlider";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { Link } from "react-router-dom";
import { showFirst22Words } from "../helper/showFirstSixWords";
import { getFileName } from "../helper/getFileName";
import { updateHeadTags } from "../helper/updateHeadTags";
import { termsTitle, whiteCard } from "../common/cssclasses";
import EahsForm from "../components/EahsForm";

export default function AboutUs() {
  const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  const AboutUsID = process.env.REACT_APP_ABOUT_US_ID;
  const { translate } = useTranslate();

  const { currentLanguage } = useSelector((state) => state.studBookSlice);
  const [aboutus, setAboutus] = useState([]);
  const [loaded, setloaded] = useState(false);

  const id = AboutUsID;

  function getCurrentLanguageUmbraco() {
    // Replace this with your logic to retrieve the current language
    // For example, you can retrieve it from localStorage or from a state variable
    const lang = localStorage.getItem("eahsLang") ?? "en";
    if (lang == "en") return "en-US";
    else return "ar-AE"; // Defaulting to English for demonstration
  }

  useEffect(() => {
    async function getdata() {
      const umbraco = await axios.get(
        `/umbraco/delivery/api/v1/content/item?id=${id}`,
        {
          headers: {
            "accept-language": getCurrentLanguageUmbraco(),
          },
        }
      );
      const formattedData = umbraco.data?.map((item) => ({
        ourVision: item?.properties?.ourVision ?? "",
        ourMessage: item?.properties?.ourMessage ?? "",
        aboutTitle: item?.properties?.aboutTitle ?? "",
        aboutCoverImage: item?.properties?.aboutCoverImage ? item?.properties?.aboutCoverImage[0]?.url : "",
        firstImage: item?.properties?.rightImage ? item?.properties?.rightImage[0]?.url : "",
        secondImage: item?.properties?.leftImage ? item?.properties?.leftImage[0]?.url : "",
        firstImageTitle: item?.properties?.rightImageTitle ?? "",
        firstImageDesc: item?.properties?.rightImageDesc ?? "",
        secondImageTitle: item?.properties?.leftImageTitle ?? "",
        secondImageDesc: item?.properties?.leftImageDesc ?? "",
        firstImageBody: item?.properties?.rightImageBody ?? "",
        secondImageBody: item?.properties?.leftImageBody ?? "",
        seoTitle: item?.properties?.seoTitle ?? '',
        seoDescription: item?.properties?.seoDescription ?? '',
        seoKeywords: item?.properties?.seoKeywords ?? []
      }));
      setAboutus(formattedData);
      if (umbraco.data.length > 0) {
        updateHeadTags({
          title: formattedData[0]?.seoTitle,
          description: formattedData[0]?.seoDescription,
          keywords: formattedData[0]?.seoKeywords
        });
        setloaded(true);
      }
    }
    getdata();
  }, [currentLanguage]);
  return (
    <>
      <>
        {
          loaded ?
            <>
              {aboutus.map((item) => (
                <>
                  <div className='row'>
                    <h2 className={termsTitle + " mb-3"}>{item?.aboutTitle}</h2>
                    {/* <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-main">
                      <div className={whiteCard}>
                        <div className="row">
                          <div className="col-4">
                            <img alt={getFileName(item.firstImage)} className="w-100 border-15" src={`${MediaBaseURL}${item.firstImage}`} />
                          </div>
                          <div className="col-8">
                            <h4 className="bold text-start" >{item?.secondImageTitle}</h4>
                            <p className="text-start mb-0">{item?.secondImageDesc}</p>
                            <p className="text-start mb-0">{showFirst22Words(item?.secondImageBody)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-main">
                      <div className={whiteCard}>
                        <div className="row">
                          <div className="col-4">
                            <img alt={getFileName(item.secondImage)} className="w-100 border-15" src={`${MediaBaseURL}${item.secondImage}`} />
                          </div>
                          <div className="col-8">
                            <h4 className="bold text-start" >{item?.firstImageTitle}</h4>
                            <p className="text-start mb-0">{item?.firstImageDesc}</p>
                            <p className="text-start mb-0">{showFirst22Words(item?.firstImageBody)}</p>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-main">
                      <div className={whiteCard}>
                        <div className="row">
                          <div className="col-2">
                            <img alt={getFileName(BaseURL + "/assets/img/vision.png")}  className="w-100 border-15" src={BaseURL + "/assets/img/vision.png"} />
                          </div>
                          <div className="col-10">
                            <h4 className="bold text-start" >{translate('web.ourVision', 'Our Vision')}</h4>
                            <p className="text-start mb-0">{item.ourVision}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-main">
                      <div className={whiteCard}>
                        <div className="row">
                          <div className="col-2">
                            <img alt={getFileName(BaseURL + "/assets/img/ourmission.png")} className="w-100 border-15" src={BaseURL + "/assets/img/eahscirclelogo.png"} />
                          </div>
                          <div className="col-10">
                            <h4 className="bold text-start" >{translate('web.ourMessage', 'Our Message')}</h4>
                            <p className="text-start mb-0">{item.ourMessage}</p>
                          </div>
                        </div>
                      </div>
                    </div>


                    {!!item.aboutCoverImage &&
                      <div className='col-sm-12 aboutusImageContainer'>
                        <img src={`${MediaBaseURL}${item.aboutCoverImage}`} alt="aboutus" style={{ width: 50 }} />
                      </div>
                    }

                  </div>
                  <EahsForm isSectionTitle title={translate('web.eahshistory', 'Eahs History')}>
                    <AboutUsSlider />
                  </EahsForm>
                </>
              ))}
            </>
            : (
              <Loader />
            )
        }
      </>
    </>
  );
}
